export default __webpack_public_path__ + "static/media/Temp75.51e57fc4.svg";